import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Division } from '../../models/division';
import { LoggedService } from '../../services/logged.service';
import { TablasService } from '../../services/tablas.service';
import { ConfigService } from '../../services/config.service';
import { UsuariosService } from '../../services/usuarios.service';
import { Region } from '../../models/region';
import { AdmService } from '../../services/adm.service';

@Component({
  selector: 'app-selector-regiones',
  templateUrl: './selector-regiones.component.html'
})
export class SelectorRegionesComponent implements OnInit {

  @Input()
  regionRecibida: Region | null = null;
  //regionRecibida: EventEmitter<Region> = new EventEmitter<Region>();
  @Output()
  regionEmitida: EventEmitter<Region> = new EventEmitter<Region>();
  regiones: Region[] = [];
  selectedRegionId: string | null = null; 

  constructor(private loggedService: LoggedService,
    private admService: AdmService,
    private usuariosService: UsuariosService,
    private configService: ConfigService) { }


  public Etiquetas: {

    FilterRegion: string;
  }

  ngOnInit() {

    this.regiones = [];
    this.Etiquetas = {

      FilterRegion: this.configService.etiquetas.FilterRegion
    }
    if (this.regionRecibida) {
      this.selectedRegionId = this.regionRecibida.id;
    }
  }

  selectRegion(region: any) {
    if (typeof region != 'undefined') {

      this.regionEmitida.emit(region);
    }
  }

  cRegiones(idpais: any) {
    if (typeof idpais != 'undefined') {
      this.admService.cRegiones(idpais, null, null).subscribe((data: Region[]) => {
        this.regiones = [];
        if (data.length) {

          this.regiones = data;
        }
      });
    }
  }
}
